<key-admin-section-editor [handler]="handler"
    [entity]="entity"
    [editable]="editable"
    [editing]="editing"
    [saveable]="saveable"
    [errorMessage]="errorMessage"
    [actions]="handler.actions"
    [showHeader]="showHeader"
    (onEdit)="onStartEdit()"
    (onSave)="onSave()"
    (onCancel)="onCancel()"
    (onAction)="onAction($event)">

    <div outside
        *ngIf="!editing && displayValues"
        class="info-display pt-3">
        <table>
            <tr *ngFor="let item of displayValues">
                <td>{{ item.name }}</td>
                <td *ngIf='item.value'>
                    <span *ngIf="!item.href" [innerHTML]="item.value"></span>
                    @if(item.href) {
                        @if(item.href.external) {
                            <a [href]="item.href.url" target="_blank">
                                {{ item.value }}
                                <kui-icon name="arrow-up-right-from-square" />
                            </a>
                        }
                        @else {
                            <a [routerLink]="item.href">{{item.value}}</a>
                        }
                    }
                    <span *ngIf="item.unit"
                        class="units">{{item.unit}}</span>
                </td>
                <td *ngIf='!item.value && entity'><span class="muted">{{ 'SHARED.NONE' | translate }}</span></td>
            </tr>
        </table>
    </div>

    <div outside
        *ngIf="editing"
        class="p-3"
        [class.pt-4]="inline">
        <key-form-builder [inline]="inline"
            [form]="formDefinition"
            [errors]="errors"
            (onChange)="onFormChange($event)"
            [values]="formValues"></key-form-builder>
    </div>

</key-admin-section-editor>